var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPharmaIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.589,
    height: 79.633,
    viewBox: "0 0 80.589 79.633",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_620_44",
    "data-name": "Component 620 \\u2013 44",
    transform: "translate(1.75 1.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30173",
    "data-name": "Group 30173",
    transform: "translate(-4897.441 -1871.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30172",
    "data-name": "Group 30172",
    transform: "translate(4897.441 1906.538)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26264",
    "data-name": "Path 26264",
    d: "M4913.17,1993.457l3.992,3.993a12.812,12.812,0,0,0,18.119,0h0a12.813,12.813,0,0,0,0-18.119l-7.984-7.985-18.12,18.119-7.984-7.985a12.812,12.812,0,0,1,0-18.119h0a12.812,12.812,0,0,1,18.119,0l4.29,4.29",
    transform: "translate(-4897.441 -1959.608)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26265",
    "data-name": "Path 26265",
    d: "M4914.266,1979.952h0a7.177,7.177,0,0,0,0,10.15l2.915,2.916",
    transform: "translate(-4906.359 -1971.932)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26266",
    "data-name": "Path 26266",
    d: "M4978.409,2024.693h0a7.177,7.177,0,0,0,0-10.15l-2.915-2.915",
    transform: "translate(-4944.722 -1991.12)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_26267",
    "data-name": "Path 26267",
    d: "M4916.675,1900.877a35.025,35.025,0,1,1,38.417,40.945",
    transform: "translate(-11.651)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26268",
    "data-name": "Path 26268",
    d: "M4935.314,1910.176a28.133,28.133,0,1,1,33.537,34.832",
    transform: "translate(-22.942 -10.59)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    y2: 4.049,
    transform: "translate(4939.508 1883.863)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x1: 4.049,
    transform: "translate(4958.617 1907.02)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_473",
    "data-name": "Ellipse 473",
    cx: 3.933,
    cy: 3.933,
    r: 3.933,
    transform: "translate(4933.947 1907.02) rotate(-45)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x2: 7.594,
    y2: 11.11,
    transform: "translate(4929.695 1892.664)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x1: 12.43,
    y2: 9.952,
    transform: "translate(4942.578 1894.611)",
    fill: "none",
    stroke: "#71cccf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmaIcon5);
export default __webpack_public_path__ + "static/media/pharma_icon5.f572a71c4023d51bd23a0f00a80ba7cb.svg";
export { ForwardRef as ReactComponent };